module.exports = __webpack_public_path__ + "static/media/manifest.a506c85d.svg";